export default "<div class=\"not-found\">\n    <img src={{imageUrl}}>\n</div>\n";